import { apolloClient } from "@App/graphql/client";
import { ApolloProvider as ApolloProviderBase } from "@apollo/client";
import { ApolloErrorHandlingProvider } from "./ApolloErrorHandlingProvider";

const ApolloProvider = ({ children }) => {
  return (
    <ApolloProviderBase client={apolloClient}>
      <ApolloErrorHandlingProvider>{children}</ApolloErrorHandlingProvider>
    </ApolloProviderBase>
  );
};

export default ApolloProvider;
